import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ServerAPI from '../ServerAPI';
import * as TimeFormatter from '../utils/TimeFormatter';

import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import {green500,blue500,orange500,red500,gray500} from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';

import Check from 'material-ui/svg-icons/navigation/check';
import ErrorOutline from 'material-ui/svg-icons/alert/error-outline';
import AlarmOn from 'material-ui/svg-icons/action/alarm-on';
import RadioButtonChecked from 'material-ui/svg-icons/toggle/radio-button-checked';

import JobAvatar from './JobAvatar';


import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';

// Run API test on every reload
//ServerAPI.testAPI(ServerAPI);
export default
@observer class JobList extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  emptyIfUndefined(value) {
    if(value) {
      return ' '+value;
    }
    return '';
  }

  gotoJobDetailPage(job) {
    var id_machine=job.id_machine;
    var starttime=job.start_time.getTime();
    var self = this;
    return function() {
      self.context.router.push(`/jobs/job/${encodeURI(id_machine)}/${starttime}`);
    }
  }

  // Pagination

  isBottom(el) {    
    return el.getBoundingClientRect().bottom <= window.innerHeight + 20; // Constant required for some webpage sizes
  }
  
  componentDidMount() {
    document.addEventListener('scroll', this.trackScrolling);
  }
  
  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackScrolling);
  }
  
  trackScrolling = () => {
    const wrappedElement = document.getElementById('list');
    
    if (this.isBottom(wrappedElement) && !AppModel.fetchingMoreJobs) {
      AppModel.fetchingMoreJobs = true;
      AppModelUtils.fetch_recent_user_domain_jobs()
      .then(res => {
        console.log(res);
        AppModel.sortJobList();
      })
    }
  };

  render() {
    function showJob(job) {
      if(job.running) { return null;}
      var job_color = {
        'SUCCESS' : green500,
        'ABORT'   : blue500,
        'ALARM'   : orange500,
        'ERROR'   : red500
      }[job.status] || gray500;
      var job_icon = {
        'SUCCESS' : (<Check />),
        'ABORT'   : (<RadioButtonChecked />),
        'ALARM'   : (<AlarmOn />),
        'ERROR'   : (<ErrorOutline />)
      }[job.status] || (<ErrorOutline />);
      return (
        <ListItem
            key={job.key}
            leftAvatar={JobAvatar.pickRightJobAvatar(job) }
            primaryText={uiMsg("JL_ROOM","Room")+": "+job.location_name + this.emptyIfUndefined(job.building)+", " + TimeFormatter.dateAndTime(job.start_time)}
            secondaryText={<p>
              {uiMsg('JL_MACHINE',"Machine")}:{job.machine_name + " ("+job.id_machine+")"},&nbsp;
              {uiMsg('JL_USER',"user")}:{job.user_id}, <br></br>
              {uiMsg('JL_JOB_RAN_FOR',"Job ran for <X> minutes",job.minutes.toFixed(0))},&nbsp;
              {uiMsg('JL_STATUS',"status")}: <span style={{color:job_color}}>{job.status}</span>
            </p>}
            secondaryTextLines={2}
            onTouchTap={this.gotoJobDetailPage(job).bind(this)}
         />
      )
    }
    
    return (
      <div>
        <List id='list'>
            <Subheader>{uiMsg('JL_COMPLETED_JOBS',"Completed Jobs")}</Subheader>
          {this.props.jobs.map(showJob.bind(this))}
        </List>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/JobList.jsx
 **/